import { BedDouble, ClipboardCheck, HeartPulse, LogOut } from "lucide-react";
import { PageHeader } from "@/components/common";

const PARTS = [
  [BedDouble, "Ward & bed management", "Live occupancy across wards, bed allocation and transfers."],
  [ClipboardCheck, "Admissions", "Admit from an outpatient consultation, with deposit and insurance pre-authorisation."],
  [HeartPulse, "Nursing care plans", "Medication rounds, vitals charting and shift handovers."],
  [LogOut, "Discharge billing", "Daily bed charges, procedures and pharmacy rolled into one discharge invoice."],
];

export default function Inpatient() {
  return (
    <>
      <PageHeader eyebrow="Roadmap" title="Inpatient module" subtitle="An optional add-on that any clinic in your group can switch on when it starts admitting patients." />
      <div className="rounded-2xl bg-slate-950 p-8 text-white" data-testid="inpatient-coming-soon">
        <span className="rounded-full bg-amber-400/15 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-amber-300">Coming soon</span>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {PARTS.map(([Icon, t, d]) => (
            <div key={t} className="rounded-xl border border-white/10 p-5"><Icon className="h-5 w-5 text-teal-400" /><p className="mt-4 font-display font-semibold">{t}</p><p className="mt-1 text-sm text-slate-400">{d}</p></div>))}
        </div>
      </div>
    </>
  );
}
